export const NAMESPACE = "EventLightSessionsSubmissions";

export const TABLE_INSTANCE_ID = "sessions";
export const VIEWPICKER_INSTANCE_ID = "sessions";
export const TABLE_VIEW_ID = "sessions-table";

export const SIDEBAR_OPTION_IDS = {
  VIEW_PICKER: "viewPicker",
  SHOW_HIDE_FIELDS: "showHideFields",
  FIELDS: "fields",
  SORT_BY: "sortBy"
};

export const SIDEBAR_OPTIONS = [
  SIDEBAR_OPTION_IDS.VIEW_PICKER,
  SIDEBAR_OPTION_IDS.SHOW_HIDE_FIELDS,
  SIDEBAR_OPTION_IDS.FIELDS,
  SIDEBAR_OPTION_IDS.SORT_BY
];

export const DRAFT_SIDEBAR_OPTIONS = [
  SIDEBAR_OPTION_IDS.FIELDS,
  SIDEBAR_OPTION_IDS.SORT_BY
];

export const STATUS = {
  ALL: "all",
  ACCEPTED: "accepted",
  ACCEPT_QUEUE: "accept_queue",
  PENDING: "pending",
  DECLINE_QUEUE: "decline_queue",
  DECLINED: "declined",
  DRAFT: "draft"
};

export const ROW_ACTIONS = {
  EDIT: "row-edit",
  DUPLICATE: "row-duplicate",

  VIEW_RECORD: "row-viewRecord",
  SEND_EMAIL: "row-sendEmail",
  SEND_ALL_ITEMS: "row-sendAllItems",
  SEND_ALL_PASSES: "row-sendAllPasses",
  SEND_ALL_MEALS: "row-sendAllMeals",
  SEND_ALL_PASSES_MEALS: "row-sendAllPassesMeals",
  SEND_ALL_ASSETS: "row-sendAllAssets",
  SEND_LOGIN: "row-sendLogin",
  SEND_LINK: "row-sendLink",
  COPY_LOGIN: "row-copyLogin",
  COPY_LINK: "row-copyLink",
  OPEN_LINK: "row-openLink",
  DOCUMENT_REQUESTS: "row-documentRequests",
  ASSIGN_OWNERS: "row-assignOwners",
  CHANGE_GROUP: "row-changeGroup",
  CHANGE_PERSON: "row-changeGroup",
  GENERATE_DOCUMENT: "row-generateDocument",
  RUN_REPORT: "row-runReport",
  UPLOAD_FILES: "row-uploadFiles",
  DELETE_RECORDS: "row-deleteRecords",
  VIEW_PERSON: "row-viewPerson",
  ASSIGN_TASK: "assign-task",
  REMOVE_ASSIGNMENT_TASK: "remove-assignment-task"
};
